function gestionSuplemento(datosCristal) {
  const arraySuplemento = { SUPL_R: [], SUPL_L: [] };
  const nombresSuplementos = [];

  if (datosCristal.length > 0) {
    for (
      let j = 0;
      j < datosCristal.length;
      j++
    ) {
      nombresSuplementos.push(
        datosCristal[j].descripcion,
      );
      const suplementos = datosCristal[j];
      arraySuplemento.SUPL_R.push(suplementos);
      arraySuplemento.SUPL_L.push(suplementos);
    }
  }


  arraySuplemento.nombresSuplementos = nombresSuplementos;
  return arraySuplemento;
}

export function formatearValoresSuplementoTrazadora(ojo, control, valores) {
  if (control == 1) {
    if (ojo === 'derecho') {
      return {
        tipo_montura: valores.tipo_montura,
        forma_basica: valores.forma,
        cota_a: valores.cota_A,
        cota_b: valores.cota_B,
        cota_d: valores.cota_D,
        dnp: valores.distancia_anasopupilar_OD,
        espesor_borde: valores.espesor_al_borde_OD,
        cota_temporal: valores.cota_temporal_OD,
        cota_nasal: valores.cota_nasal_OD,
        cota_superior: valores.cota_superior_OD,
        cota_inferior: valores.cota_inferior_OD,
        altura_focal: valores.altura_focal_OD,
      };
    }
    return {
      tipo_montura: valores.tipo_montura,
      forma_basica: valores.forma,
      cota_a: valores.cota_A,
      cota_b: valores.cota_B,
      cota_d: valores.cota_D,
      dnp: valores.distancia_anasopupilar_OI,
      espesor_borde: valores.espesor_al_borde_OI,
      cota_temporal: valores.cota_temporal_OI,
      cota_nasal: valores.cota_nasal_OI,
      cota_superior: valores.cota_superior_OI,
      cota_inferior: valores.cota_inferior_OI,
      altura_focal: valores.altura_focal_OI,
    };
  }
  if (control == 2 || control == 3) {
    const valoresArray = valores.split(';');
    if (ojo === 'derecho') {
      return {
        diop_x: valoresArray[1],
        diop_y: valoresArray[5],
        eje_x: valoresArray[2],
        eje_y: valoresArray[6],
      };
    }
    return {
      diop_x: valoresArray[3],
      diop_y: valoresArray[7],
      eje_x: valoresArray[4],
      eje_y: valoresArray[8],
    };
  }
  if (control == 4) {
    const valoresArray = valores.split(';');
    if (ojo === 'derecho') {
      return {
        espesor: valoresArray[1],
        tipo: valoresArray[0],
      };
    }
    return {
      espesor: valoresArray[1],
      tipo: valoresArray[0],
    };
  }
  if (control == 8) {
    const valoresArray = valores.split('-');
    if (ojo === 'derecho') {
      const valoresArrayOjo = valoresArray[0].split(';');
      return {
        dnp: valoresArrayOjo[1],
        altura_focal: valoresArrayOjo[0],
      };
    }
    const valoresArrayOjo = valoresArray[1].split(';');
    return {
      dnp: valoresArrayOjo[1],
      altura_focal: valoresArrayOjo[0],
    };
  }
  if (control == 9) {
    if (ojo === 'derecho') {
      return {
        base: valores,
      };
    }
    return {
      base: valores,
    };
  }
  if (control == 11) {
    if (ojo === 'derecho') {
      return {
        diametro: valores,
      };
    }
    return {
      diametro: valores,
    };
  }
  if (control == 51 || control == 53) {
    if (ojo === 'derecho') {
      return {
        valor: valores,
      };
    }
    return {
      valor: valores,
    };
  }
  return null;
}
export function formatearDatosLente(lente, foco, graduacion, miFabricante, descripcionOficial, pasillo, miColor) {
  const lentes = [];
  const tratamientoSeleccionado = lente.tratamiento[0];
  const colorSeleccionado = lente.colores[0];
  const esRx = tratamientoSeleccionado.esRX;
  const lenteOD = (graduacion.derecho) ? {
    id: lente.tGamaId,
    id_lente_pel: tratamientoSeleccionado.catalogoId,
    ojo: 'D',
    hay_oferta: true,
    codigo: lente.tGamaCodigo,
    descripcion_oficial: lente.tGamaDescripcion ? lente.tGamaDescripcion : descripcionOficial,
    descripcion_propia: lente.nombreCompleto ? lente.nombreCompleto : null,
    descripcion: lente.tGamaDescripcion ? lente.tGamaDescripcion : lente.nombreCompleto,
    estado: esRx,
    fabricacion: true,
    rango: '0',
    cdgprovoriginal: lente.proveedor.corto !== '' ? lente.proveedor.corto : miFabricante.proveedor,
    dproveedororiginal: lente.proveedor.largo !== '' ? lente.proveedor.largo : miFabricante.proveedor,
    cdgfocooriginal: lente.foco.id,
    cdgtipooriginal: lente.material.id,
    alias: lente.tGamaId,
    indice: lente.indice,
    pvp: lente.precio,
    diametro: lente.diametrosSeleccionados.D,
    pedido_cdglente: lente.tGamaCodigo,
    costo: '',
    es_monofocal: lente.esMonofocalFabricacion,
    blnestado: esRx ? 'SI' : 'NO',
    pimp: '0',
    grupo: 1,
    color: 0,
    tipo_color: 0,
    vision: graduacion.derecho.modo,
    tipoLente: '1',
    proveedor: lente.proveedor,
    esMiCatalogo: lente.esMiCatalogo,
    miCatalogoId: tratamientoSeleccionado.catalogoId,
    lenteId: lente.lenteId,
    tratamientoId: tratamientoSeleccionado.id,
    colorDetalleId: colorSeleccionado.id,
    miColorId: miColor ? miColor.id : null,
    miFabricante: miFabricante || null,
    tipoProgresivoId: pasillo.id,
    esRX: esRx,
  } : null;
  const lenteOI = (graduacion.izquierdo) ? {
    id: lente.tGamaId,
    id_lente_pel: tratamientoSeleccionado.catalogoId,
    ojo: 'I',
    hay_oferta: true,
    codigo: lente.tGamaCodigo,
    descripcion_oficial: lente.tGamaDescripcion ? lente.tGamaDescripcion : descripcionOficial,
    descripcion_propia: lente.nombreCompleto ? lente.nombreCompleto : null,
    descripcion: lente.tGamaDescripcion ? lente.tGamaDescripcion : lente.nombreCompleto,
    estado: esRx,
    fabricacion: true,
    rango: '0',
    cdgprovoriginal: lente.proveedor.corto !== '' ? lente.proveedor.corto : miFabricante.proveedor,
    dproveedororiginal: lente.proveedor.largo !== '' ? lente.proveedor.largo : miFabricante.proveedor,
    cdgfocooriginal: lente.foco.id,
    cdgtipooriginal: lente.material.id,
    alias: lente.tGamaId,
    indice: lente.indice,
    pvp: lente.precio,
    diametro: lente.diametrosSeleccionados.I,
    pedido_cdglente: lente.tGamaCodigo,
    costo: '',
    es_monofocal: lente.esMonofocalFabricacion,
    blnestado: esRx ? 'SI' : 'NO',
    pimp: '0',
    grupo: 1,
    color: 0,
    tipo_color: 0,
    vision: graduacion.izquierdo.modo,
    tipoLente: '1',
    proveedor: lente.proveedor,
    esMiCatalogo: lente.esMiCatalogo,
    miCatalogoId: tratamientoSeleccionado.catalogoId,
    lenteId: lente.lenteId,
    tratamientoId: tratamientoSeleccionado.id,
    colorDetalleId: colorSeleccionado.id,
    miColorId: miColor ? miColor.id : null,
    miFabricante: miFabricante || null,
    tipoProgresivoId: pasillo.id,
    esRX: esRx,
  } : null;
  if (lenteOD) lentes.push(lenteOD);
  if (lenteOI) lentes.push(lenteOI);
  return lentes;
}
export function convertirSuplementosPel(suplementos, proveedor) {
  const supls = [];
  for (let i = 0; i < suplementos.length; i++) {
    const suplemento = suplementos[i];
    supls.push({
      adicional: null,
      anyo: null,
      campanya: -1,
      clindro4: false,
      codigo: suplemento.suplemento.idSuplemento,
      codigo_suplemento: suplemento.suplemento.codigoPedido,
      control: suplemento.suplemento.control,
      desc_oficial: suplemento.suplemento.descripcion,
      descripcion: suplemento.suplemento.descripcion,
      es_compensador: false,
      es_no_telematico: false,
      es_tratamiento: suplemento.suplemento.tipoSuplemento === 2,
      esta_incluido: suplemento.incluido,
      estado: 'SI',
      fin_oferta: null,
      graduacion: -1,
      id: suplemento.suplemento.idSuplemento,
      id_tipo: suplemento.suplemento.tipoSuplemento,
      incluido: suplemento.incluido,
      inicio_oferta: null,
      lente: suplemento.suplemento.idSuplemento,
      obligatorio: suplemento.obligatorio,
      oferta: -1,
      pedido_auto: true,
      proveedor,
      pvo: suplemento.pvo,
      pvp: suplemento.pvp,
      pvp_central: '0',
      pvp_central_oferta: '0',
      pvp_oferta: '0',
      pvp_tienda: '0',
      pvp_tienda_oferta: '0',
      sucursal: '-1',
      tipo_suplemento: suplemento.suplemento.tipoSuplemento,
    });
  }
  return { D: supls, I: supls };
}

export function convertirDatosVentanaTrazadora({
  lente, foco, graduacion, miFabricante, descripcionOficial, pasillo, miColor, datosSuplementos, montura, materialesYBiselados,
}) {
  let lenteL = null;
  let lenteR = null;

  const HBOX_R = null;
  const HBOX_L = null;
  const VBOX_R = null;
  const VBOX_L = null;
  const DBL = null;

  const ESPESOR_R = null;
  const ESPESOR_L = null;
  let LNAM_R_DES = '';
  let LNAM_L_DES = '';
  let LNAM_R = null;
  let LNAM_L = null;
  const FNAM = null;
  let RX_R = null;
  let RX_L = null;
  const IPD_R = null;
  const IPD_L = null;
  let Cderecho = null;
  let Cizquierdo = null;
  const datos_adiccionales = {};
  let extra_data = null;
  const modoEdicion = true;
  // Siempre pasamos la de lejos
  let ejeR = null;
  let ejeL = null;
  let cilindroR = null;
  let cilindroL = null;
  let esferaR = null;
  let esferaL = null;

  const graduacionD = graduacion.derecho.isSelected ? graduacion.derecho : null;
  const graduacionI = graduacion.izquierdo.isSelected ? graduacion.izquierdo : null;

  const adicionD = graduacionD ? graduacionD.ADD : null;
  const adicionL = graduacionI ? graduacionI.ADD : null;
  const OCHT_R = (graduacionD && lente.alturaFocal) ? lente.alturaFocal.D : null;
  const OCHT_L = (graduacionI && lente.alturaFocal) ? lente.alturaFocal.I : null;

  let hayLenteDerecha = false;
  let hayLenteIzquierda = false;

  let datosReturn = { };
  const lentes = formatearDatosLente(lente, foco, graduacion, miFabricante, descripcionOficial, pasillo, miColor);
  const proveedor = miFabricante ? miFabricante.proveedor : lente.proveedor.corto;
  const suplementos = convertirSuplementosPel(datosSuplementos, proveedor);
  for (let i = 0; i < lentes.length; i++) {
    if (lentes[i].ojo === 'D') {
      lenteR = lentes[i];
      LNAM_R_DES = lenteR.descripcion_propia !== null ? `${lenteR.descripcion_oficial} (${lenteR.descripcion_propia})` : lenteR.descripcion_oficial;
      LNAM_R = lenteR.pedido_cdglente;
      Cderecho = lenteR.diametro;
      ejeR = lenteR.vision === 'cerca' ? graduacionD.AXISC : graduacionD.AXISL;
      cilindroR = lenteR.vision === 'cerca' ? graduacionD.CILC : graduacionD.CILL;
      esferaR = lenteR.vision === 'cerca' ? graduacionD.ESFC : graduacionD.ESFL;
      hayLenteDerecha = true;
    }
    if (lentes[i].ojo === 'I') {
      lenteL = lentes[i];
      LNAM_L_DES = lenteL.descripcion_propia != null ? `${lenteL.descripcion_oficial} (${lenteL.descripcion_propia})` : lenteL.descripcion_oficial;
      LNAM_L = lenteL.pedido_cdglente;
      Cizquierdo = lenteL.diametro;
      ejeL = lenteL.vision === 'cerca' ? graduacionI.AXISC : graduacionI.AXISL;
      cilindroL = lenteL.vision === 'cerca' ? graduacionI.CILC : graduacionI.CILL;
      esferaL = lenteL.vision === 'cerca' ? graduacionI.ESFC : graduacionI.ESFL;
      hayLenteIzquierda = true;
    }
  }
  RX_R = `Eje:${
    ejeR
  } `
    + `Cilindro:${
      cilindroR
    } `
    + `Esfera:${
      esferaR
    } `
    + `Adicion:${
      adicionD}`;
  RX_L = `Eje:${
    ejeL
  } `
    + `Cilindro:${
      cilindroL
    } `
    + `Esfera:${
      esferaL
    } `
    + `Adicion:${
      adicionL}`;
  switch (lentes[0].tipoLente) {
    case '1':
      datosReturn = {
        LTYP_CODE_R: '',
        LTYP_CODE_L: '',
        CRIB_R: Cderecho, // diametro
        CRIB_L: Cizquierdo, // diametro
        HBOX_R,
        HBOX_L,
        VBOX_R,
        VBOX_L,
        DBL,
        IPD_R,
        IPD_L,
        OCHT_R,
        OCHT_L,
        ESPESOR_R,
        ESPESOR_L,
        LNAM_R,
        LNAM_R_DES,
        LNAM_L,
        LNAM_L_DES,
        RX_R,
        RX_L,
        FNAM,
        FORMA: 1,
      };
      break;

    case '3':
      datosReturn = {
        LTYP_CODE_R: 'PR',
        LTYP_CODE_L: 'PR',
        CRIB_R: Cderecho,
        CRIB_L: Cizquierdo,
        CORRLEN_R: '',
        CORRLEN_L: '',
        DESC_PR_R: '',
        DESC_PR_L: '',
        DIOP_X_D: '',
        EJE_X_D: '',
        DIOP_Y_D: '',
        EJE_Y_D: '',
        DIOP_X_I: '',
        EJE_X_I: '',
        DIOP_Y_I: '',
        EJE_Y_I: '',
        HBOX_R,
        HBOX_L,
        VBOX_R,
        VBOX_L,
        DBL,
        IPD_R,
        IPD_L,
        OCHT_R,
        OCHT_L,
        ESPESOR_R,
        ESPESOR_L,
        LNAM_R,
        LNAM_R_DES,
        LNAM_L,
        LNAM_L_DES,
        RX_R,
        RX_L,
        FNAM,
        FORMA: 1,
      };
      break;

    case '2':
      datosReturn = {
        LTYP_CODE_R: 'BI',
        LTYP_CODE_L: 'BI',
        LFAM_CODE_R: 'CT',
        LFAM_CODE_L: 'CT',
        CRIB_R: Cderecho,
        CRIB_L: Cizquierdo,
        SGOCIN_R: 2.5, // no lo tengo
        SGOCIN_L: 2.5, // no lo tengo
        SGOCUP_R: 4, // no lo tengo
        SGOCUP_L: 4, // no lo tengo

        HBOX_R,
        HBOX_L,
        VBOX_R,
        VBOX_L,
        DBL,
        IPD_R,
        IPD_L,
        OCHT_R,
        OCHT_L,
        ESPESOR_R,
        ESPESOR_L,
        LNAM_R,
        LNAM_R_DES,
        LNAM_L,
        LNAM_L_DES,
        RX_R,
        RX_L,
        FNAM,
        FORMA: 1,
      };
      break;
    default:
      break;
  }
  datosReturn.SuplementosI = suplementos.I != null
    ? gestionSuplemento(suplementos.I)
    : gestionSuplemento(suplementos.D);
  datosReturn.oma_original = montura.datosOma && montura.datosOma.oma_original ? montura.datosOma.oma_original : null;
  extra_data = {
    admite_biselado_forma_oma: montura.datosOma ? montura.datosOma.admite_biselado_forma_oma : '',
    fecha_modificacion_forma: montura.datosOma ? montura.datosOma.fecha_modificacion_forma_oma : '',
    descripcionMontura: montura.id ? montura.descripcion : '',
    modoEdicion,
    esPel2: true,
    hayLenteIzquierda,
    hayLenteDerecha,
  };
  return {
    metodo: 'loadDataPEL',
    shape: null,
    message: JSON.stringify(datosReturn),
    extra_data,
    shape_original_OMA: null,
    materiales_montura_biselado: materialesYBiselados, // Obtener de peticion a materiales
    prov: proveedor,
    info_modo_fabricante: {}, // Falta rellenar
    datos_adiccionales,
    datos_ficha_optometrica: {}, // Falta rellenar
    incompatibilidades: [], // Falta rellenar,
    pendienteDePedir: false,
    diametrosPosibles: lente.diametros, // Falta rellenar
  };
}
export function formatearDatosDeTrazadora(datosLenteSeleccionada, tracerData, suplementosTrazadora) {
  const { lentes } = datosLenteSeleccionada;
  const lentesFormateadas = lentes.map((l) => {
    let descripcionCompleta = l.nombreCompleto;
    let alturaFocal = null;
    const suplementos = l.suplementos.map((s) => {
      const supl = s.suplemento;
      for (let i = 0; i < suplementosTrazadora.length; i += 1) {
        const suplementoTrazadora = suplementosTrazadora[i];
        if (supl.idSuplemento === suplementoTrazadora.codigo && supl.control == suplementoTrazadora.control) {
          descripcionCompleta += ` + ${supl.descripcion}`;
          const parametros = formatearValoresSuplementoTrazadora(l.ojo, supl.control, suplementoTrazadora.valor);
          if (parametros) {
            if (parametros.altura_focal) {
              alturaFocal = parametros.altura_focal;
              delete parametros.altura_focal;
            }
            return { ...s, parametros, obligatorio: suplementoTrazadora.check };
          }
          return { ...s, cadena_valor: suplementoTrazadora.valor, obligatorio: suplementoTrazadora.check };
        }
      }
      return { ...s, obligatorio: false };
    }).filter(s => s.obligatorio == 1);
    return {
      ...l,
      alturaFocal,
      descripcionCompleta,
      info_trazadora: tracerData,
      suplementos,
    };
  });
  return { ...datosLenteSeleccionada, lentes: lentesFormateadas };
}
